export const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.amiabila"
export const APPLE_STORE = "https://apps.apple.com/ro/app/amiabila/id1635148751"
